import { createElement } from "react";
import { IconType } from "react-icons";
import { TbExclamationCircle, TbFilter, TbUserSearch } from "react-icons/tb";

import { SoftColor, softColors } from "@/constants/colors";

export enum SearchStatuses {
    INITIAL = "initial",
    EMPTY = "empty",
    ERROR = "error",
}
// icon={TbUserSearch}
// title="Yolcu Arayın"
// description="Aratmak istediğiniz yolcunun adını veya uçuş numarasını giriniz."
const searchStatuses: Record<
    SearchStatuses,
    {
        iconBoxShadow: string;
        icon: IconType;
        title: string;
        description: string;
        color: SoftColor;
    }
> = {
    [SearchStatuses.INITIAL]: {
        iconBoxShadow:
            "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset",
        icon: TbUserSearch,
        title: "Yolcu Arayın",
        description: "Aratmak istediğiniz yolcunun adını veya uçuş numarasını giriniz.",
        color: softColors.grey,
    },
    [SearchStatuses.EMPTY]: {
        iconBoxShadow:
            "rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset",
        icon: TbFilter,
        title: "Yolcu Bulunamadı",
        description: "Girdiğiniz bilgilere sahip yolcu bulunamadı.",
        color: softColors.grey,
    },
    [SearchStatuses.ERROR]: {
        iconBoxShadow:
            "rgba(255, 0, 0, 0.7) 0px 50px 100px -20px, rgba(255, 0, 0, 0.4) 0px 30px 60px -30px, rgba(255, 50, 50, 0.5) 0px -2px 6px 0px inset",
        color: softColors.red,
        icon: TbExclamationCircle,
        title: "Hata Oluştu",
        description: "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.",
    },
};

function GlobalSearchStatusCard({ size = 40, variant }: { size?: number; variant: SearchStatuses }) {
    const status = searchStatuses[variant];
    if (!status) return null;
    const { icon, title, description, color, iconBoxShadow } = status;
    return (
        <div
            className=" shadow border rounded-lg p-6 flex items-center justify-center text-center flex-col gap-2"
            style={{ borderColor: color.bg }}
        >
            <div className="border-l   rounded-full p-1    rotate-[-60deg]" style={{ borderColor: color.hover }}>
                <div
                    className="bg-gray-200  rounded-full   grid place-content-center"
                    style={{
                        width: size * 2,
                        height: size * 2,
                        boxShadow: iconBoxShadow,
                    }}
                >
                    {createElement(icon, {
                        className: "text-gray-400 rotate-[60deg]",
                        style: { fontSize: size },
                    })}
                </div>
            </div>
            <div>
                <div className=" font-semibold " style={{ color: color.text }}>
                    {title}
                </div>
                <div className=" text-gray-400 text-sm">{description}</div>
            </div>
        </div>
    );
}

export default GlobalSearchStatusCard;
